function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Theme from '@adsk/alloy-react-theme';
export var modalStyle = {
  maxWidth: '600px',
  width: '100%',
  maxHeight: '90vh',
  height: 'auto'
};
export var modalBodyStyle = {
  minHeight: '180px',
  paddingBottom: '40px'
};
export var fieldStyle = {
  paddingTop: '20px',
  width: '100%'
};
export var firstColumnFieldStyle = {
  padding: '20px 20px 0 0',
  width: '50%'
};
export var secondColumnFieldStyle = {
  paddingTop: '20px',
  width: '50%'
};
export var flexWrapperStyle = {
  display: 'flex'
};
export var secondColumnNoLabelFieldStyle = {
  paddingTop: '44px',
  width: '50%'
};
export var timezoneTooltipLinkStyle = _objectSpread({
  color: Theme.colors.white,
  textDecoration: 'none'
}, Theme.typography.bodySmallBold);
export var templateTooltipLinkDividerStyle = {
  margin: '10px 0'
};
export var templateTooltipLinkStyle = timezoneTooltipLinkStyle;
export var loaderContainerStyle = {
  zIndex: 100,
  width: '100%',
  height: '100%',
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  top: '0px',
  left: '0px'
};
export var loaderBoxStyle = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'rgba(238,238,238,0.6)',
  borderRadius: '15px',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '20px'
};
export var ringCustomStyle = {
  width: 40,
  height: 40
};
export var loaderTextStyle = {
  marginTop: '5px'
};
export var templateLabelContainer = {
  display: 'flex'
};
export var templateLabelInfoPopover = {
  marginLeft: 5
};
export var templateLabelInfoPopoverIcon = {
  color: ''
};
export var templateGroupLabel = {
  container: {
    fontSize: 11
  },
  title: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginBottom: 5,
    marginTop: 2
  }
};
//# sourceMappingURL=styles.js.map